<template>
  <div class="permission-panel">
    <div class="permission-header" v-if="currentMenuPermission">
      <h3>
        {{ $i18n('Current Menu Permission') }}:
        {{ currentMenuPermission }}
      </h3>
    </div>
    <s-table :data="permissionData" processValue="-">
      <s-table-column
        v-for="col in basicColumns"
        :key="col.prop"
        v-bind="col"
        :width="col.width"
      >
      </s-table-column>
    </s-table>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import router from '@/router';
import {
  convertRouteNameToPermission,
  permissionStorage,
} from '@/utils/permissionStorage';

interface PermissionData {
  value: string;
  index: number;
  hasPermission: string;
}

@Component
export default class PermissionPanel extends Vue {
  permissionData: PermissionData[] = [];

  currentMenuPermission = '';

  basicColumns = [
    {
      label: this.$i18n('Index'),
      prop: 'index',
      width: 20,
    },
    {
      label: this.$i18n('Permission Value'),
      prop: 'value',
      width: 400,
    },
    {
      label: this.$i18n('Has Permission'),
      prop: 'hasPermission',
      width: 80,
    },
  ];

  timer: any = null;

  mounted() {
    this.loadData();
    this.timer = setInterval(() => {
      this.loadData();
    }, 3000);
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange() {
    this.loadData();
  }

  loadData() {
    const routeName = router.currentRoute.name ?? null;
    const isMenuHide = router.currentRoute?.meta?.menuHide;
    if (!isMenuHide) {
      this.currentMenuPermission = convertRouteNameToPermission(
        router.currentRoute.name
      );
    } else {
      this.currentMenuPermission = '';
    }
    const permissions = permissionStorage.get(routeName);
    this.permissionData = permissions.map((value, index) => ({
      value,
      index: index + 1,
      hasPermission: this.$store.state.permission.userPermission.includes(value)
        ? this.$i18n('Y')
        : this.$i18n('N'),
    }));
  }
}
</script>

<style scoped lang="scss">
.permission-panel {
  width: 100%;
  height: 100%;

  .permission-header {
    margin-bottom: 16px;
    border-radius: 4px;
    padding: 12px;
    background-color: #f5f5f5;

    h3 {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      color: #333333;
    }
  }
}
</style>
